import { Anchor, FormattedText } from "client/Components";
import { ReactElement } from "react";
import styles from "./ImageAttributionLink.module.less";
import { ImageAttributionKind, ImageAttributionViewModel } from "client/Api/common";
import { localize } from "client_legacy/ndaw/culture";
import { never } from "client_legacy/ndaw/errors";

export type ImageAttributionLinkProps = {
	attribution: ImageAttributionViewModel;
	trackingId: string;
};

export const ImageAttributionLink = (props: ImageAttributionLinkProps): ReactElement => {
	const {
		attribution,
		trackingId
	} = props;

	switch (attribution.kind) {
		case ImageAttributionKind.Pixabay:
			const {
				authorId,
				authorName
			} = attribution;

			return (
				<Anchor
					className={styles.root}
					href={getPixabayUserUrl(authorName, authorId)}
					target="_blank"
					trackingId={trackingId}
				>
					<FormattedText
						text={localize("_NameViaProvider")}
						thingsToReplace={[
							{
								what: "{{Name}}",
								filler: authorName
							},
							{
								what: "{{Provider}}",
								filler: localize("_Pixabay")
							}
						]}
					/>
				</Anchor>
			);
		default:
			never(attribution.kind);
	}
};
ImageAttributionLink.displayName = "ImageAttributionLink";

function getPixabayUserUrl(
	authorName: string,
	authorId: number
): string {
	return `https://pixabay.com/users/${authorName}-${authorId}/`;
}